import type { ITextV2PublicProps as IPublicPropsText } from '@alfa-bank/site-text-v2/src/models';
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';

import type { TSizes } from './models';

export const ICON_CARD_WIDTH = 270;

// Для размера Heading передаются просто числа от 1 до 5.
// Это штука соотносит эти числа с настройками для Text
// Разбивки для Desktop/Mobile не нужно.
// Так как для карточек всегда использовались HeadingDesktop и TextDesktop
export const mapHeadingSizeToTextView: Record<TSizes, IPublicPropsText['view']> = {
    1: 'xlarge',
    2: 'large',
    3: 'medium',
    4: 'small',
    5: 'xsmall',
    6: 'accent-primary-large',
};

export const STYLER_FOR_TITLE_DESKTOP: IStyler = { marginTop: 0, marginBottom: 16 };
export const STYLER_FOR_TITLE_MOBILE: IStyler = { marginTop: 0, marginBottom: 8 };
